function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 0H0v24h24V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.503 9.026v-.015c0-1.18.951-2.139 2.231-2.139 1.273 0 2.216.943 2.216 2.124v.015c0 1.18-.95 2.139-2.231 2.139-1.273 0-2.216-.943-2.216-2.124zm3.297 0v-.015c0-.606-.437-1.135-1.081-1.135-.667 0-1.066.514-1.066 1.12v.015c0 .606.437 1.135 1.081 1.135.667 0 1.066-.514 1.066-1.12z",
  fill: "#006A4E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.7 12.427h.94l-.118.544c.353-.373.743-.63 1.28-.63.916 0 1.634.669 1.691 1.756.076 1.453-.97 2.516-2.151 2.516-.723 0-1.153-.357-1.426-.815l-.424 1.973h-.94L4.7 12.427zm2.876 1.74c-.033-.63-.441-1.017-1.024-1.017-.753 0-1.436.753-1.39 1.623.03.598.473 1.04 1.087 1.04.769 0 1.375-.737 1.327-1.646zM14.27 10.858h.94l-1.225 5.67h-.94l1.225-5.67zM14.97 15.992l.42-.637c.442.334.924.505 1.343.505.404 0 .637-.17.637-.442v-.016c0-.318-.435-.427-.916-.575-.606-.17-1.282-.42-1.282-1.204v-.015c0-.777.645-1.25 1.46-1.25.513 0 1.072.178 1.507.465l-.373.668c-.396-.24-.815-.388-1.157-.388-.365 0-.575.17-.575.412v.015c0 .295.443.42.924.575.598.186 1.274.458 1.274 1.196v.015c0 .863-.668 1.29-1.522 1.29-.583 0-1.227-.21-1.74-.614zM18.632 14.493v-.015c0-1.173.831-2.136 2.004-2.136 1.305 0 1.965 1.025 1.965 2.205 0 .086-.008.171-.015.265h-3.014c.101.668.575 1.04 1.18 1.04.459 0 .785-.17 1.111-.489l.552.49c-.389.465-.925.768-1.678.768-1.188 0-2.105-.862-2.105-2.128zm3.037-.303c-.062-.605-.42-1.08-1.04-1.08-.575 0-.98.443-1.065 1.08h2.105zM11.82 12.427v2.457c0 .457-.371.828-.829.828h-.2a.829.829 0 01-.828-.828v-2.457h-.906v2.455c0 .958.776 1.735 1.735 1.735h.2c.957 0 1.734-.777 1.734-1.735v-2.455h-.906z",
  fill: "#009597"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 6.948h1.166l-.1.444c.336-.33.67-.52 1.13-.52.897 0 1.614.65 1.672 1.762.076 1.457-.98 2.5-2.138 2.5-.644 0-1.034-.269-1.323-.675l-.388 1.825H1.354L2.5 6.947zM5.227 8.71c-.029-.537-.383-.859-.904-.859-.644 0-1.208.644-1.167 1.426.027.522.414.874.927.874.629 0 1.187-.613 1.144-1.441zM9.295 6.94h-.433c-1.1 0-1.991.89-1.991 1.99v2.119h1.173V8.892c0-.45.364-.814.814-.814h.437V6.94z",
  fill: "#006A4E"
});

function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCa;